import { CategoryState, DataActiveStatusEnum, IData } from "../types";

export const defaultFormData: IData = {
  _id: "",
  createdAt: "",
  updatedAt: "",
  title: "",
  status: DataActiveStatusEnum.ACTIVE,
  featuredImage: "",
  sortOrder: 0,
};

export const initialState: CategoryState = {
  formData: { ...defaultFormData },
  list: [],
  allList: [],
  loading: false,
  buttonLoading: false,
  toggleLoading: false,
  search: "",
  pageNo: 1,
  pageSize: 30,
  totalRow: 0,
  orderBy: "",
  orderDir: "",
};
